import DocusignRedirect from './DocusignRedirect';

export default DocusignRedirect;
